import React, { useState } from 'react'

export const TextArea: React.FC<InputTextProps> = ({
  label = '',
  placeholder = 'Escribe aquí...',
  size = 'default',
  hidden = false,
  value,
  name,
  error,
  register,
  rules,
  containerClasses,
  maxLength,
  isUpperValue = false,
  rows = 3,
  title = false,
  disableInput = false,
}) => {
  const [valueInput, setValueInput] = useState(value)

  return (
    <div className={`${containerClasses}`}>
      <label className="block">
        <span className="font-medium text-primary-900 text-xs dark:text-white">
          {label}
        </span>
        <textarea
          name={name}
          className={`cursor-text transition w-full ${
            !title && 'dark:bg-gray-600 dark:border-gray-600 dark:text-white hover:bg-primaryGray-300 dark:hover:bg-primaryGray-600'
          } ${
            title &&
            'dark:bg-black dark:border-black dark:text-white focus:border-transparent hover:bg-primaryGray-300 dark:hover:bg-primaryGray-600'
          } 
        ${
          size === 'small'
            ? 'h-inputSmall'
            : size === 'large'
            ? 'h-inputLarge'
            : 'h-inputDefault '
        } 
        ${error ? 'border-danger focus:border-danger' : ''}`}
          placeholder={placeholder}
          maxLength={maxLength}
          rows={rows || 5}
          hidden={hidden}
          value={valueInput && valueInput}
          readOnly={disableInput ? true : false}
          style={{ height: '80px' }}
          ref={register ? register(rules) : undefined}
          onChange={(e) =>
            isUpperValue ? setValueInput(e?.target?.value?.toUpperCase()) : null
          }
        ></textarea>
      </label>
    </div>
  )
}

type InputProps = JSX.IntrinsicElements['input']

interface InputTextProps {
  label?: string
  placeholder?: string
  password?: boolean
  size?: 'small' | 'large' | 'default'
  hidden?: boolean
  value?: string
  defaultValue?: any // usado por ahora en lista de clientes y proveedores para cargar numeros de telefonos
  containerClasses?: any
  title?: boolean
  phone?: boolean
  innerProps?: InputProps
  [key: string]: any
  isUpperValue?: boolean
  rows?: number
}
